"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerContainer = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const PlayerContainer = exports.PlayerContainer = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eryog930"
} : {
  target: "eryog930",
  label: "PlayerContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1saf8wx",
  styles: "display:flex;align-items:center;justify-content:center;width:100%;height:auto"
} : {
  name: "1saf8wx",
  styles: "display:flex;align-items:center;justify-content:center;width:100%;height:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});